import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

// Services
import useAccommodationService from '../../../../../../../services/accommodationService';

// Components
import SelectField from '../../../../../../atoms/SelectField/SelectField';
import ToggleCheck from '../../../../../../atoms/ToggleCheck/ToggleCheck';

function Features({ formik }) {
  const { t } = useTranslation();

  const { getAccommodationFeatures } = useAccommodationService();

  const { data: features, isLoading: isFeaturesLoading } = useQuery('getFeatures', getAccommodationFeatures);

  const getSelect = useCallback((name, options, transKeyForOptions, isLoading) => (
    <SelectField
      id={name}
      name={name}
      options={options?.map((option) => ({ label: t(`${transKeyForOptions}.${option}`), value: option }))}
      label={t(`accommodations.marketing.form.${name}`)}
      error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
      setFieldTouched={formik.setFieldTouched}
      setFieldValue={formik.setFieldValue}
      value={formik.values[name]}
      isMulti
      disabled={isLoading}
      withTags
    />
  ), [formik]);

  return (
    <div>
      <h3 className="fs-20 m-b-25">{t('accommodations.marketing.sub.features')}</h3>

      <div className="input_max">
        {getSelect('features', features?.data?.accommodationFeatures, 'accommodations.features', isFeaturesLoading, 5)}
      </div>

      <hr className="m-t-30 m-b-40" />

      <h3 className="fs-20 m-b-25">{t('accommodations.marketing.sub.breakfast')}</h3>

      <ToggleCheck
        labels={[t('accommodations.marketing.form.isBreakfastIncluded')]}
        name="isBreakfastIncluded"
        onValueChange={(checked) => formik.setFieldValue('isBreakfastIncluded', checked)}
        isChecked={formik.values.isBreakfastIncluded}
      />
    </div>
  );
}

Features.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      isBreakfastIncluded: PropTypes.bool,
    }),
    errors: PropTypes.shape({}),
    touched: PropTypes.shape({}),
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func,
  }).isRequired,
};

export default Features;
